import { FixedContainerV2, Image } from '@slot-nx/core'
import { BitmapText, Container } from '@pixi/react'
import { gameConfig } from '../config'

import { Container as PixiContainer, BitmapText as PixiBitmapText } from 'pixi.js'
import { useEffect, useRef } from 'react'
import { multiplierService } from '../domain/spin/service/MultiplierService'

export const MultiplierReel = () => {
  const multiplierReelRef = useRef<PixiContainer>()
  const multiplierHighLightNumberRef = useRef<PixiBitmapText>()

  useEffect(() => {
    multiplierService.initMultiplierSymbol()
    multiplierService.multiplierReelRef = multiplierReelRef.current as PixiContainer
    multiplierService.multiplierHighLightNumberRef = multiplierHighLightNumberRef.current as PixiBitmapText
  }, [])

  return (
    <Container name="MultiplierReelBar">
      <Image
        name="MultiplierReelBackground"
        image="muliplierBar"
        width={1043}
        height={213}
        x={gameConfig.resolution.width / 2}
        y={280}
        anchor={[0.5, 0.5]}
      />
      <Image
        name="multiplierSelectBg"
        image="multiplierSelectBg"
        width={162}
        height={156}
        x={120}
        y={280}
        anchor={[0.5, 0.5]}
      />
      <Image
        name="MultiplierSelectFrame"
        image="multiplierSelectFrame"
        width={183}
        height={177}
        x={120}
        y={280}
        anchor={[0.5, 0.5]}
      />

      <FixedContainerV2
        name="MultiplierReel"
        width={gameConfig.nodeWidth * 6}
        height={gameConfig.nodeHeight}
        x={40}
        y={200}
      >
        <Container
          ref={(el: PixiContainer | null) => {
            multiplierReelRef.current = el as PixiContainer
          }}
          width={gameConfig.nodeWidth * 6}
          height={gameConfig.nodeHeight}
          x={78.5}
          y={78.5}
        >
        </Container>
      </FixedContainerV2>
      <BitmapText
        name="highLightNumber"
        anchor={[0.5, 1.15]}
        style={{ fontName: 'FontW', fontSize: 32 }}
        y={280}
        x={120}
        ref={(el: PixiBitmapText) => {
          multiplierHighLightNumberRef.current = el
        }}
      />
    </Container>
  )
}
